import { render } from "./specPopup.vue?vue&type=template&id=61e362ac&scoped=true"
import script from "./specPopup.vue?vue&type=script&lang=js"
export * from "./specPopup.vue?vue&type=script&lang=js"

import "./specPopup.vue?vue&type=style&index=0&id=61e362ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e362ac"]])

export default __exports__